module.exports = __webpack_public_path__ + "img/c02_buildingchainmailandboiledleatherarmor_Normal_ua.b2d4a6d3.webp";